/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
// React Components
import React, { useState, useContext, useEffect } from "react";
import "./AccountDetailsv2.scss";
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
import clsx from "clsx";
import { green } from "@material-ui/core/colors";
import CircularProgress from "@material-ui/core/CircularProgress";
// import DispatchContext from '../DispatchContext'
import Axios from "axios";
import Page from "../Page";
// Mui Components
import { makeStyles } from "@material-ui/core/styles";
import {
  Select,
  Button,
  FormControl,
  MenuItem,
  InputLabel,
  InputAdornment,
  TextField,
} from "@material-ui/core/";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import kuwaitFlag from "../../Assets/images/kuiwat flag.png";
import EmailValidate from "../EmailValidate";
import { IconButton } from "@mui/material";
import LoaderAnimation from "../../Components/LoaderAnimation";
import maleLogo from "../../Assets/images/male-avatar.png";
import femaleLogo from "../../Assets/images/female-avatar.png";
import { DropzoneArea } from "material-ui-dropzone";
import CardProfile from "../../Components/avatarUpdate/avatarUpdate";
import { LocalConvenienceStoreOutlined } from "@material-ui/icons";
import { getCookie, setCookie, parseCookieJson } from "../../Functions/cookieFunction";
import { get_lang } from "../../Functions/getLang";
import { handleUserInfo } from "../../helper/customeObj";
import { handleError } from "../../Functions/getAlert";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "122px",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

function AccountDetailsv2() {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [selectedCountryId, setSelectedCountryId] = useState(
    // appState.profile.meta.country
    ""
  );
  const [selectedCityId, setSelectedCityId] = useState(
    // appState.profile.meta.city
    ""
  );
  const [selectedAreaId, setSelectedAreaId] = useState(
    // appState.profile.meta.area
    ""
  );
  // var selectedCountryId = appState.profile.meta.country;
  // var selectedCityId = appState.profile.meta.city;
  // var selectedAreaId = appState.profile.meta.area;
  // console.log(selectedCountryId)
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState({});
  const [imgObj, setImgObj] = useState({});
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");

  const handleChangesFiles = (event) => {
    setFiles(event.target.files[0]);
  };

  // // console.log(files)
  const handleGetImgUrl = (imgObj, imagePreviewUrl) => {
    // console.log(imgObj);
    setFiles(imgObj);
  };

  const [validateStatus, setValidateStatus] = useState(false);
  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });
  const { t } = useTranslation();

  let myAddress, dob, city, area;
  if (appState.profile.address == null) {
    myAddress = "";
  } else {
    myAddress = appState.profile.address;
  }
  if (appState.profile.city == null) {
    city = "";
  } else {
    city = appState.profile.city;
  }
  if (appState.profile.area == null) {
    area = "";
  } else {
    area = appState.profile.area;
  }
  const [selectedDate, setSelectedDate] = useState(appState.profile.dob);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });

  const [updateData, setUpdateData] = useState({
    first_name:
      appState.profile.userFirstName != undefined
        ? appState.profile.userFirstName
        : null,
    last_name:
      appState.profile.userLastName != undefined
        ? appState.profile.userLastName
        : null,
    middle_name:
      appState.profile.userMiddleName != undefined
        ? appState.profile.userMiddleName
        : null,
    email: appState.profile.email != undefined ? appState.profile.email : null,
    dob:
      appState.profile.userDob != undefined ? appState.profile.userDob : null,
    number:
      appState.profile.number != undefined ? appState.profile.number : null,
    country_id:
      appState.profile.userCountryId != undefined
        ? appState.profile.userCountryId
        : null,
    country: "",
    city_id:
      appState.profile.userCityId != undefined
        ? appState.profile.userCityId
        : null,
    city: "",
    area_id:
      appState.profile.userAreaId != undefined
        ? appState.profile.userAreaId
        : null,
    area: "",
    address:
      appState.profile.userAddress != undefined
        ? appState.profile.userAddress
        : null,
    gender:
      appState.profile.userGender != undefined
        ? appState.profile.userGender
        : null,
    country_code: "965",
  });
  // console.log("updateData", updateData);
  const [countries, setCountries] = useState([]);
  // console.log(countries)
  const [getcity, setGetCity] = useState([]);
  const [areas, setAreas] = useState([]);
  const [emailVerifyStatus, setemailVerifyStatus] = useState("");

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // console.log(appState.profile);
  }, []);

  const [imageurl, setImageUrl] = useState("");

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("user_id", updateData.user_id);
    formData.append("first_name", updateData.first_name);
    formData.append("last_name", updateData.last_name);
    formData.append("middle_name", updateData.middle_name);
    formData.append("email", updateData.email);
    formData.append("address", updateData.address);
    formData.append("dob", updateData.dob);
    // formData.append("country", updateData.country_id);
    // formData.append("city", updateData.city_id);
    // formData.append("area", updateData.area_id);
    formData.append("gender", updateData.gender);
    formData.append("image", files);
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}customer/profile`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${appState.token}`,
            "Content-type": `multipart/form-data`,
          },
        }
      );
      // console.log("chl raha h", response)
      if (response.data.success) {
        // console.log(response.data.data);
        setImageUrl(response.data.data.image);
        let getData = handleUserInfo(response.data.data);
        appDispatch({
          type: "UpdateProfile",
          profile: getData,
        });
        setCookie("Profile", JSON.stringify(getData));

        setAlertMessage({
          open: true,
          message: "Your profile has been updated!",
          alertSuccess: true,
        });
      } else {
        setAlertMessage({
          open: true,
          message: `${response.data.message} ${response.data.data[0]}`,
          alertSuccess: false,
        });
      }

      setLoading(false);
    } catch (e) {
      handleError(e, appDispatch);
      setLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => setAlertMessage({ open: false }), 3000);
  }, [alertMessage.open]);

  const updateField = (e) => {
    setUpdateData({
      ...updateData,
      [e.target.name]: e.target.value,
    });
    if (e.target.name == "country") {
      for (var i = 0; i < countries.length; i++) {
        if (e.target.value == countries[i].id) {
          setUpdateData({
            ...updateData,
            country_id: countries[i].id,
            country: countries[i].name,
            city_id: "",
            city: "",
            area_id: "",
          });
          setGetCity(countries[i].city);
        }
      }
    } else if (e.target.name == "city") {
      for (var i = 0; i < getcity.length; i++) {
        if (e.target.value == getcity[i].id) {
          setUpdateData({
            ...updateData,
            city_id: getcity[i].id,
            city: getcity[i].name,
          });
          setAreas(getcity[i].areas);
        }
      }
    } else if (e.target.name == "area") {
      setUpdateData({
        ...updateData,
        area_id: e.target.value,
        // area: e.target.value,
      });
    }
  };

  useEffect(() => {
    if (countries.length > 0) {
      for (var i = 0; i < countries.length; i++) {
        if (selectedCountryId == countries[i].id) {
          setUpdateData({
            ...updateData,
            country_id: countries[i].id,
            country: countries[i].name,
          });
          setGetCity(countries[i].city);
          for (var j = 0; j < countries[i].city.length; j++) {
            if (selectedCityId == countries[i].city[j].id) {
              setUpdateData({
                ...updateData,
                city_id: countries[i].city[j].id,
                city: countries[i].city[j].name,
              });
              setAreas(countries[i].city[j].areas);
              for (var k = 0; k < countries[i].city[j].areas.length; k++) {
                if (selectedAreaId == countries[i].city[j].areas[k].id) {
                  setUpdateData({
                    ...updateData,
                    area_id: countries[i].city[j].areas[k].id,
                    area: countries[i].city[j].areas[k].name,
                  });
                }
              }
            }
          }
        }
      }
    }
  }, [countries, selectedCityId, selectedCountryId, selectedAreaId]);

  const getCountries = async () => {
    setIsLoading(true)
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_API_URL}country`,
        {
          headers: {
            Authorization: `Bearer ${appState.token}`,
          },
        }
      );
      setCountries(response.data.data);
      setIsLoading(false)
    } catch (e) {
      handleError(e, appDispatch);
      setIsLoading(false)
    }
  };

  useEffect(() => {
    getCountries();
    handleGetImgUrl();
  }, [appState.profile]);

  // useEffect(() => {
  //   if (appState.profile.email_verified_at) {
  //     setIsLoading(false);
  //     setemailVerifyStatus(appState.profile.email_verified_at);
  //   }
  // }, [appState.profile.email_verified_at]);

  const [genderList, setGenderList] = useState([
    {
      name: "gender",
      gender: "male",
    },
    {
      name: "gender",
      gender: "female",
    },
  ]);

  useEffect(() => {
    let localProfile = parseCookieJson(getCookie("Profile")) || {};
    setUpdateData({
      user_id: localProfile.userId,
      first_name: localProfile.userFirstName,
      last_name: localProfile.userLastName,
      middle_name: localProfile.userMiddleName,
      email: localProfile.email,
      dob: localProfile.userDob, //selectedDate
      number: localProfile.number,
      country: "",
      country_id: localProfile.userCountryId,
      city_id: localProfile.userCityId,
      area_id: localProfile.userAreaId,
      address: localProfile.userAddress,
      city: "",
      area: "",
      gender:
        localProfile.userGender !== "" || null
          ? localProfile.userGender
          : "male",
      country_code: "965",
    });
    setSelectedCountryId(localProfile.userCountryId);
    setSelectedCityId(localProfile.userCityId);
    setSelectedAreaId(localProfile.userAreaId);
    // console.log("upd", updateData);
  }, [appState.profile]);

  if (isLoading)
    return (
      <div className={`${classes.root}`}>
        <LoaderAnimation />
      </div>
    );

  return (
    <Page title="Account Details">
      <EmailValidate
        open={open}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
        setValidateStatus={setValidateStatus}
      />

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>
      <div id="AccountDetailsv2">
        <div className="row m-0 pt-3">
          <div className="col-md-4">
            <h4
              className={`py-2 ${
                appState.langValue === "ar" ? "text-right" : "text-left"
              }`}
            >
              <strong>
                <span>{t("form.personal-info")}</span>{" "}
              </strong>
            </h4>
          </div>
        </div>

        <form
          className={`form ${
            appState.langValue == "ar" ? "classForArabicSelect" : " "
          }`}
          onSubmit={handleUpdate}
          noValidate
          autoComplete="off"
        >
          {/* <div className="row  d-flex justify-content-center ">
            <div className="col-md-12">
              <CardProfile
                appState={appState}
                handleGetImgUrl={handleGetImgUrl}
              />
            </div>
          </div> */}

          <div className="row m-0 accountDetailsFormv2">
            <div
              className={`${
                appState.langValue === "ar" ? "profileformRtlv2" : ""
              } col-md-4 form_col`}
            >
              <TextField
                id="full-name_field"
                name="first_name"
                onChange={updateField}
                value={updateData.first_name}
                type="text"
                className="w-100"
                label={t("form.First-Name")}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
              />
            </div>
            <div
              className={`${
                appState.langValue === "ar" ? "profileformRtlv2" : ""
              } col-md-4 form_col`}
            >
              <TextField
                id="full-name_field"
                name="middle_name"
                onChange={updateField}
                value={updateData.middle_name}
                type="text"
                className="w-100"
                label={t("form.Middle-Name")}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
              />
            </div>
            <div
              className={`${
                appState.langValue === "ar" ? "profileformRtlv2" : ""
              } col-md-4 form_col`}
            >
              <TextField
                id="full-name_field"
                name="last_name"
                onChange={updateField}
                value={updateData.last_name}
                type="text"
                className="w-100"
                label={t("form.Last-Name")}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
              />
            </div>
            <div
              className={`${
                appState.langValue === "ar" ? "profileformRtlv2" : ""
              } col-md-4 form_col`}
            >
              <TextField
                id="email_field"
                name="email"
                // disabled={appState.profile.email != "" ? true : ""}
                onChange={updateField}
                value={updateData.email}
                type="email"
                className="w-100"
                label={t("form.Email")}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
              />
            </div>
            <div
              className={`${
                appState.langValue === "ar" ? "profileformRtlv2" : ""
              } col-md-4 form_col`}
            >
              {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                margin="normal"
                id="dob-field"
                label={t("form.Dob")}
                name="dob"
                format={"yyyy-MM-dd"}
                value={"hello"} 
                className="w-100 m-0"
                onChange={handleDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider> */}

              <TextField
                id="dob-field"
                name="dob"
                onChange={updateField}
                value={updateData.dob}
                type="date"
                className="w-100"
                label={t("form.Dob")}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
                // InputProps={{
                //   startAdornment: (
                //     <InputAdornment
                //       position="start"
                //       className=""
                //     ></InputAdornment>
                //   ),
                // }}
              />
            </div>

            <div
              className={`${
                appState.langValue === "ar"
                  ? "profileformRtlv2 profileformRtlGenderv2"
                  : ""
              } col-md-4 form_col`}
            >
              <TextField
                id="filled-select-currency"
                select
                name="gender"
                label={t("form.gender")}
                value={updateData.gender}
                onChange={updateField}
                variant="filled"
              >
                {genderList.map((val, ind) => (
                  <MenuItem
                    name={val.name}
                    value={val.gender.toLocaleLowerCase()}
                    key={val.name}
                  >
                    {val.gender === "male" ? t("form.male") : t("form.female")}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            {/* <div
              className={`${
                appState.langValue === "ar" ? "profileformRtlv2" : ""
              } col-md-4 form_col`}
            >
              <TextField
                id="filled-select-currency"
                select
                label={t("form.Countries")}
                name="country"
                value={updateData.country_id}
                onChange={updateField}
                variant="filled"
              >
                {updateData.country ? <MenuItem defaultValue={updateData.country.en} value={updateData.country_id} key={updateData.country_id}>
                  {updateData.country.en}
                </MenuItem> : }
                {countries ? (
                  countries.map((country) => (
                    <MenuItem value={country.id} key={country.id}>
                      {get_lang(country.name, appState.langValue)}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="None">
                    <em>None</em>
                  </MenuItem>
                )}
              </TextField>
            </div> */}
            {/* <div
              className={`${
                appState.langValue === "ar" ? "profileformRtlv2" : ""
              } col-md-4 form_col`}
            >
              <TextField
                id="filled-select-currency"
                select
                label={t("form.City")}
                name="city"
                value={updateData.city_id}
                onChange={updateField}
                variant="filled"
              >
                {getcity.length > 0 ? (
                  getcity.map((city) => (
                    <MenuItem value={city.id} key={city.id}>
                      {get_lang(city.name, appState.langValue)}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>{t("form.Please-select-country-first")}</MenuItem>
                )}
              </TextField>
            </div> */}

            {/* <div
              className={`${
                appState.langValue === "ar" ? "profileformRtlv2" : ""
              } col-md-4 form_col`}
            >
              <TextField
                id="filled-select-currency"
                select
                name="area"
                label={t("form.Area")}
                value={updateData.area_id}
                onChange={updateField}
                variant="filled"
              >
                {areas.length > 0 ? (
                  areas.map((area) => (
                    <MenuItem value={area.id} key={area.id}>
                      {get_lang(area.name, appState.langValue)}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>{t("form.Please-select-city-first")}</MenuItem>
                )}
              </TextField>
            </div> */}
            {/* <div className="col-md-4 form_col">
                        <FormControl className={classes.formControl}>
                            <InputLabel id="city_label">Area</InputLabel>
                            <Select labelId="city_label" name="area" id="demo-simple-select-city" value={updateData.area} onChange={updateField}>
                                <MenuItem value="None">
                                    <em>None</em>
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div> */}
            {/* <div
              className={`${
                appState.langValue === "ar" ? "profileformRtlv2" : ""
              } col-md-4 form_col`}
            >
              <TextField
                id="address_field"
                name="address"
                onChange={updateField}
                value={updateData.address}
                type="text"
                className="w-100"
                label={t("form.Address")}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
                multiline
                maxRows="50"
              />
            </div> */}

            <div className="col-12 text-center pb-3 mt-4">
              <Button
                variant="contained"
                type="submit"
                className={`${buttonClassname} col-md-3 col-12 bg-primary login_btn`}
                disabled={loading}
                color="primary"
              >
                {loading
                  ? t("form.updating-profile")
                  : t("form.update-profile")}
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          </div>
        </form>
      </div>
    </Page>
  );
}

export default withTranslation()(AccountDetailsv2);
